<template>
  <div id="app-vue">
    <Header v-if="showHeaderFooter" :loggedIn="loggedIn" />
    <!--<v-alert
      v-if="
        loggedIn &&
          ($route.name === 'dashboard overview' || $route.name === 'dashboard')
      "
      close-text="Close Alert"
      color="#05123d"
      dark
      dismissible
      style="border-radius: 0;"
      transition="slide-y-transition"
      class="layout--margin-bottom-none"
      @click="closeAlert"
      v-model="alert"
    >
      <template v-slot:default>
        <div class="layout--flex-start">
          <IconExclamation
            class="icon layout--margin-right-xs"
            style="width: 23px; height: 23px; transform:translateY(1px);"
          />
          Welcome to the new MotionMail dashboard.
          <a class="link link--footer layout--margin-left-xxs" href="https://forms.gle/uhPYnia7uaEvovJm8"
            >Send us feedback!</a
          >
        </div>
      </template>
      <template v-slot:close>
        <button
          type="button"
          @click="closeAlert"
          class="button button--icon layout--padding-right-none layout--hide-mobile"
        >
          <IconClose style="width: 25px; height: 25px;fill:#ffffff;" /><span
            class="layout--screen-reader-only"
            >Close</span
          >
        </button>
      </template>
    </v-alert>-->
    <v-alert
      v-if="loggedIn && account.suspended" 
      dark
      color="#b2061a"
      class="layout--margin-bottom-none"
      style="border-radius: 0;"
    >
      <template v-slot:default>
          Your account is currently suspended. To resolve please follow the
          <a class="link link--footer" href="https://motionmail.freshdesk.com/support/solutions/articles/14000150789-what-do-i-do-if-my-account-is-suspended-"
            >instructions here</a
          >.
      </template>
    </v-alert>
    <v-alert
      v-for="(alert, index) in errorAlerts"
      :key="index"
      close-text="Close Alert"
      color="#b2061a"
      dark
      dismissible
      type="error"
      style="border-radius: 0;"
      transition="slide-y-transition"
      class="layout--margin-bottom-none"
    >
      <template v-slot:default>
        <div class="layout--flex-start layout--margin-left-xs">
          {{ alert.message }}
        </div>
      </template>
      <template v-slot:close>
        <button
          type="button"
          @click="closeErrorAlert(index)"
          class="button button--icon layout--padding-right-none layout--hide-mobile"
        >
          <IconClose style="width: 25px; height: 25px;fill:#ffffff;" /><span
            class="layout--screen-reader-only"
            >Close</span
          >
        </button>
 	  </template>
 	</v-alert>
    <validation-alert />
    <router-view :key="$route.fullPath.split('?')[0]" />
    <Footer v-if="showHeaderFooter" />
    <!-- enables modals to display -->
    <modals-container />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

import Login from "./pages/Login";
import Footer from "./components/Footer";
import Header from "./components/Header";
import TimeoutModal from "./components/TimeoutModal";
import InactivityModal from "./components/InactivityModal";
import IconClose from "./assets/icons/iconCloseX.svg";
import IconExclamation from "./assets/icons/iconAlertBar-Exclamation.svg";
import ValidationAlert from "./components/ValidationAlert.vue";

export default {
  name: "app",
  components: {
    Footer,
    Header,
    Login,
    TimeoutModal,
    IconClose,
    IconExclamation,
    ValidationAlert,
  },
  data() {
    return {
      timeToExpire: 0,
      timeoutModalOpen: false,
    };
  },
  //prompt user when session is about to time out
  // mounted() {
  //   let timerId = setInterval(() => {
  //     if (this.loggedIn === true) {
  //       this.timeToExpire =
  //         900000 - (new Date().getTime() - this.tokenRenewedTime);
  //       if (
  //         this.timeToExpire < 120000 &&
  //         this.timeToExpire >= 1 &&
  //         !this.timeoutModalOpen
  //       ) {
  //         this.$modal.show(
  //           TimeoutModal,
  //           { timeToExpire: this.timeToExpire, mainTimer: timerId },
  //           {},
  //           {
  //             "before-open": this.markTimeoutModalOpen,
  //             "before-close": this.markTimeoutModalClosed,
  //           }
  //         );
  //       }
  //       if (this.timeToExpire < 1) {
  //         clearInterval(timerId);
  //         this.$modal.hideAll();
  //         this.$modal.show(InactivityModal);
  //         this.logOut();
  //       }
  //     }
  //   }, 10000);
  // },
  methods: {
    ...mapActions("session", ["logOut", "closeAlert"]),
    ...mapMutations("session", ["closeErrorAlert"]),
    markTimeoutModalOpen: function() {
      this.timeoutModalOpen = true;
    },
    markTimeoutModalClosed: function() {
      this.timeoutModalOpen = false;
    },
  },
  computed: {
    ...mapGetters("session", ["loggedIn", "tokenRenewedTime", "alert", "errorAlerts"]),
    ...mapGetters("account", ["account"]),
    showHeaderFooter: function() {
      return (
        this.$route.name !== "maintenance" &&
        this.$route.name !== "payment receipt" &&
        this.$route.name !== "login" &&
        this.$route.name !== "forgot password" &&
        this.$route.name !== "change password with token" &&
        this.$route.name !== "register"
      );
    },
  },
};
</script>

<style lang="scss">
@import "./styles/main.scss";
@import "./styles/pages/mainContent.scss";

#app-vue .v-alert__wrapper {
  max-width: 1366px;
  margin: 0 auto;
  padding-left: 30px;
  padding-right: 30px;
  @include for-size(tablet-up) {
    padding-right: 25px;
  }
  @include for-size(tablet-landscape-up) {
    padding-right: 20px;
  }
  @include for-size(desktop-up) {
    padding-right: 26px;
  }
}
#app-vue .v-alert {
  padding-left: 0;
  padding-right: 0;
}
</style>
